import { useContext, useState } from "react"
import {
  Button,
  ButtonGroup,
  Inline,
  ModalBody,
  Paragraph,
  PrimaryNavigationButton,
  SmallModal,
  Tooltip,
} from "@george-labs.com/design-system"
import { useTranslation } from "react-i18next"
import "./LogoutButton.css"
import { useCounter } from "../../app/hooks"
import dayjs from "../../utils/dayjs"
import AuthContext from "../../providers/AuthProvider"

function getDuration(duration: dayjs.Dayjs): string {
  return duration.isValid() ? duration.format("mm:ss") : "00:00"
}

function LogoutButton() {
  const { t } = useTranslation()
  const authContext = useContext(AuthContext)
  const [modalIsOpen, setModalIsOpen] = useState<boolean>(false)
  const { value: counter, isUnderOneMin, isUnderTwoMin } = useCounter()
  const duration = dayjs(counter * 1000)

  return (
    <>
      <Tooltip
        enabled={isUnderTwoMin}
        content={
          <Inline>
            {t("app.logoutTimerWarning.message", {
              mins: duration.isValid() ? duration.format("mm:ss") : "00:00",
            })}
          </Inline>
        }
      >
        <PrimaryNavigationButton
          icon={PrimaryNavigationButton.ICON.LOGOUT}
          className={isUnderOneMin ? "red-button" : "logout-button"}
          onClick={() => setModalIsOpen(true)}
        >
          {isUnderOneMin ? getDuration(duration) : t("LOGOUT")}
        </PrimaryNavigationButton>
      </Tooltip>
      <SmallModal
        isOpen={modalIsOpen}
        title={t("app.logoutConfirm.title")}
        footer={
          <ButtonGroup>
            <Button
              variant={Button.VARIANT.SECONDARY}
              onClick={() => setModalIsOpen(false)}
            >
              {t("common.close3")}
            </Button>
            <Button onClick={() => authContext.logoutHandler()}>
              {t("common.logout")}
            </Button>
          </ButtonGroup>
        }
      >
        <ModalBody>
          <Paragraph>{t("app.logoutConfirm.message")}</Paragraph>
        </ModalBody>
      </SmallModal>
    </>
  )
}

export default LogoutButton
